<template><!--左侧路由窗口-->
  <div style="margin-right: -1px">
    <el-menu class="el-menu-vertical-demo" background-color='#324157' text-color="white" default-active="0">

      <el-menu-item index="1" @click="index">
        <i class="el-icon-s-home"></i>
        <span slot="title">首页详情</span>
      </el-menu-item>

      <el-submenu index="4">
        <template slot="title">
          <i class="el-icon-setting"></i><span slot="title">支付管理</span>
        </template>
        <el-menu-item-group>

        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-setting"></i><span slot="title">结算管理</span>
        </template>
      </el-submenu>

      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-setting"></i><span slot="title">商户管理</span>
        </template>
      </el-submenu>

      <el-menu-item index="6" v-on:click="logOut">
        <i class="el-icon-unlock"></i>
        <span slot="title">安全退出</span>
      </el-menu-item>

    </el-menu>
  </div>
</template>

<script>

import {LogOutApi} from "../../api/api";

export default {
  name: 'menuLeft',
  methods: {
    //  首页
    index() {
      this.$router.push("/Home/index");
    },
    logOut() {
      let type = this.$CookiesGet('type');
      LogOutApi({
        type: type
      })
      // eslint-disable-next-line
      .then(_ => {
        this.$removeToken();
        this.$CookiesClear();
        this.$notify({
          title: "",
          message: "账号退出成功",
          type: 'success'
        });
        this.$router.push('/');
      })
          // eslint-disable-next-line
          .catch(_ => {
        this.$router.push('/');
      });
    },

  },
}
</script>

<style>

</style>
